import { Box } from '@mantine/core';

function FullscreenBackground({ image }) {
  return (
    <Box
      style={{
        position: 'fixed',
        top: '3.75rem',
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: `url(${image})`,
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    />
  );
}

export default FullscreenBackground;
